import { RefObject } from 'react';

export const centerElement = (
  ref: RefObject<HTMLElement | null>,
  selectorOrElement: string | Element,
  options: ScrollIntoViewOptions = { behavior: 'smooth', block: 'center', inline: 'center' },
) => {
  if (selectorOrElement instanceof Element) {
    selectorOrElement.scrollIntoView(options);
    return;
  }

  const container = ref.current;
  if (!container) {
    return;
  }

  // Check if it's already there
  const target = container.querySelector(selectorOrElement);
  if (target) {
    target.scrollIntoView(options);
    return;
  }

  // Otherwise, observe the container until the child appears
  const observer = new MutationObserver((_, obs) => {
    const foundTarget = container.querySelector(selectorOrElement);
    if (foundTarget) {
      foundTarget.scrollIntoView(options);
      obs.disconnect(); // Stop observing immediately once found
    }
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
  });

  // Optional: Automatically disconnect after 5 seconds to prevent memory leaks
  setTimeout(() => observer.disconnect(), 5000);
};
